export interface FaqEntry {
  id: number
  q_zh: string
  q_en: string
  a_zh: string
  a_en: string
  keywords: string[]
}

export const FAQ_DATA: FaqEntry[] = [
  {
    id: 1,
    q_zh: '如何登录？忘记密码怎么办？',
    q_en: 'How do I log in? What if I forget my password?',
    a_zh:
      '打开系统首页，输入邮箱（或用户名）和密码后点击「登录」即可。若忘记密码，点击登录页「忘记密码？」链接，输入注册邮箱后系统会发送重置邮件（1小时内有效），按邮件指引设置新密码即可。',
    a_en:
      'Open the system homepage, enter your email (or username) and password, then click "Login". If you forget your password, click "Forgot password?" on the login page, enter your registered email, and the system will send a reset email (valid for 1 hour). Follow the instructions to set a new password.',
    keywords: ['登录', '密码', '忘记密码', '重置', 'login', 'password', 'forgot', 'reset'],
  },
  {
    id: 2,
    q_zh: '如何登记每日工作量（新增工作记录）？',
    q_en: 'How do I log my daily work (add a work record)?',
    a_zh:
      '点击顶栏「记录」按钮，在弹出的工作记录表单中选择分类和任务、填写日期、处理量、工时（如 1.5h 或 90m）及备注，提交后即完成登记。',
    a_en:
      'Click the "Log" button in the top navigation bar. In the popup form, select a category and task, fill in the date, volume, hours (e.g., 1.5h or 90m), and an optional note, then submit.',
    keywords: ['记录', '工作量', '登记', '新增', '工时', '处理量', 'log', 'work record', 'worklog'],
  },
  {
    id: 3,
    q_zh: '如何新建个人任务、怎么用计时器（开始 / 暂停 / 停止）？',
    q_en: 'How do I create a personal task and use the timer (start/pause/stop)?',
    a_zh:
      '进入「个人任务」页，点击「+」或新建任务按钮，填写任务信息后保存。在任务列表中，每条任务右侧有计时器控件：点「开始」计时，点「暂停」暂停，点「停止」结束并记录用时。',
    a_en:
      'Go to the "Personal Tasks" page and click the "+" or new task button. Fill in task details and save. In the task list, each task has timer controls: click "Start" to begin timing, "Pause" to pause, and "Stop" to end and record elapsed time.',
    keywords: ['个人任务', '新建', '计时器', '开始', '暂停', '停止', 'personal task', 'timer', 'start', 'pause', 'stop'],
  },
  {
    id: 4,
    q_zh: '任务如何标记完成？完成前需要填哪些内容？',
    q_en: 'How do I mark a task as complete? What fields are required before completing?',
    a_zh:
      '在「个人任务」页找到对应任务，在操作区点击「完成」按钮。系统要求完成时填写实际处理量和工时，确认后任务状态变为「已完成」。',
    a_en:
      'In the "Personal Tasks" page, find the task and click the "Complete" button. The system requires you to fill in the actual volume and hours before confirming. Once confirmed, the task status changes to "Done".',
    keywords: ['完成', '标记', '处理量', '工时', '任务状态', 'complete', 'done', 'finish', 'mark'],
  },
  {
    id: 5,
    q_zh: '在哪查看效能榜单？排名怎么算？',
    q_en: 'Where can I view the leaderboard? How is the ranking calculated?',
    a_zh:
      '点击顶栏「效能榜单」进入榜单页。排名按照所选时间范围和任务筛选条件计算各成员的总处理量，处理量高者排名靠前。可通过任务筛选器和预设选择参与计入的任务。',
    a_en:
      'Click "Leaderboard" in the top navigation bar. Rankings are calculated based on each member\'s total volume within the selected time range and task filter. Higher volume means higher rank. Use the task filter and presets to choose which tasks count.',
    keywords: ['榜单', '排名', '效能', '处理量', '筛选', 'leaderboard', 'ranking', 'performance'],
  },
  {
    id: 6,
    q_zh: '在哪检索 / 筛选工作记录？怎么导出 CSV？',
    q_en: 'Where can I search/filter work records? How do I export CSV?',
    a_zh:
      '进入「数据管理」或「全局查询」页，使用顶部筛选区（登记人、分类、日期范围、关键字等）筛选后点「搜索」。找到所需记录后点「导出 CSV」即可下载当前筛选结果。',
    a_en:
      'Go to "Data Management" or "Global Search". Use the filter area (registrant, category, date range, keyword, etc.) and click "Search". Once you have the desired results, click "Export CSV" to download the filtered data.',
    keywords: ['搜索', '检索', '筛选', '导出', 'CSV', '工作记录', '数据管理', '全局查询', 'search', 'filter', 'export'],
  },
  {
    id: 7,
    q_zh: '如何导出季度工作量分析报表？',
    q_en: 'How do I export a quarterly workload analysis report?',
    a_zh:
      '进入「季度报表」页（需 Manager/Admin 权限），选择年份和季度，可选是否附加自定义任务排行，点击「生成并下载」即可获取 Excel 报表。',
    a_en:
      'Go to "Quarterly Report" (requires Manager/Admin permission). Select the year and quarter, optionally include a custom task ranking sheet, then click "Generate & Download" to get the Excel report.',
    keywords: ['季度', '报表', '导出', 'Excel', '分析', 'quarterly', 'report', 'export', 'download'],
  },
  {
    id: 8,
    q_zh: '管理者如何给成员分派任务（含批量分派）？',
    q_en: 'How does a manager assign tasks to members (including batch assignment)?',
    a_zh:
      '进入「任务分派」页，在看板的「成员 × 日期」格子上点「+分派」打开弹窗。选择任务类型：单任务（单选）、Bundle（多任务一起派）或笛卡尔积批量（多成员 × 多日期 × 多任务 = 批量 N 条）。填选好后点「确认分派」。',
    a_en:
      'Go to the "Assignments" page. Click the "+" button in a "Member × Date" cell to open the assignment dialog. Choose the assignment type: single task, Bundle (multiple tasks at once), or Cartesian batch (multiple members × dates × tasks = N items total). Then click "Confirm Assignment".',
    keywords: ['分派', '任务', '批量', '看板', '管理者', 'assign', 'batch', 'task', 'manager', 'cartesian'],
  },
  {
    id: 9,
    q_zh: '如何导入 / 维护排班？各排班状态是什么含义？',
    q_en: 'How do I import/maintain duty schedules? What do the schedule statuses mean?',
    a_zh:
      '进入「排班管理」页，在「排班导入」Tab 上传 Excel 文件（sheet 名须为 YYYYMM 格式）预览并确认导入。排班网格 Tab 支持单格点击或 Shift 批量选格修改状态。常见状态含义：上班（正常工作日）、值班（非工作日上班）、调休（工作日休息）、休假、请假、加班等。',
    a_en:
      'Go to "Duty Schedule". Under the "Schedule Import" tab, upload an Excel file (sheet names must be YYYYMM format), preview, and confirm. The Schedule Grid tab lets you click individual cells or Shift-click to select multiple cells and change their status. Common statuses include: Work (regular workday), On Duty (non-workday duty), Comp Off (workday rest), Vacation, Leave, Overtime, etc.',
    keywords: ['排班', '导入', '状态', '值班', '调休', '休假', '请假', '加班', 'schedule', 'import', 'status', 'duty'],
  },
  {
    id: 10,
    q_zh: '如何切换中英文界面？',
    q_en: 'How do I switch between Chinese and English?',
    a_zh:
      '点击顶栏右侧的「英文 / 中文」切换按钮即可实时切换界面语言。注意：任务分类名和任务名称始终保持英文原值，不随语言切换而翻译。',
    a_en:
      'Click the "中文 / English" toggle button on the right side of the top navigation bar to switch the interface language instantly. Note: task category names and task names always display their original English values and are not translated.',
    keywords: ['语言', '中文', '英文', '切换', 'language', 'switch', 'Chinese', 'English'],
  },
  {
    id: 11,
    q_zh: '不同角色（成员 / 经理 / 管理员）分别能看到和能做什么？',
    q_en: 'What can different roles (Member/Manager/Admin) see and do?',
    a_zh:
      '成员（Member）：可登记工作量、管理个人任务、查看榜单、全局查询。经理（Manager）：在成员基础上，还可访问核心概览、区域透视、非标记录、任务分派、排班管理、季度报表、人员管理、任务字典、审计日志，并可管理其可见范围内的团队。管理员（Admin）：拥有经理全部权限，另可访问 Admin 控制台（角色管理、系统配置、邀请 Manager/Member）、修改全局配置。',
    a_en:
      'Member: Can log work, manage personal tasks, view the leaderboard, and use global search. Manager: Everything a Member can do, plus Overview, Regional Pivot, Noncompliant Records, Assignments, Duty Schedule, Quarterly Report, Personnel, Task Dictionary, Audit Log, and team management within their visible scope. Admin: All Manager permissions, plus access to Admin Console (role management, system config, invite Manager/Member) and global configuration.',
    keywords: ['角色', '成员', '经理', '管理员', '权限', '能做什么', 'role', 'member', 'manager', 'admin', 'permission'],
  },
  {
    id: 12,
    q_zh: '管理员如何邀请成员 / 经理、如何升降级？',
    q_en: 'How does an Admin invite members/managers and change their roles?',
    a_zh:
      '邀请成员：进入「Admin 控制台」→「角色管理」，点击「+ 邀请 Member」，填写邮箱、显示名、区域、小组后提交，系统发送激活邮件。邀请 Manager：点「邀请 Manager」同理。升降级：在角色管理列表找到该成员，点「升为 Manager」或「降为 Member」，按提示确认即可。也可在「人员管理」页操作。',
    a_en:
      'To invite a member: Go to "Admin Console" → "Role Management", click "+ Invite Member", fill in the email, display name, region, and group, then submit. The system sends an activation email. To invite a Manager: click "Invite Manager" similarly. To change roles: find the member in the role management list and click "Promote to Manager" or "Demote to Member", then confirm.',
    keywords: ['邀请', '升级', '降级', '管理员', 'Admin', '角色管理', '激活', 'invite', 'promote', 'demote', 'role'],
  },
]
